module.exports = __webpack_public_path__ + "static/media/3655E8_2_0.f39c260d.woff";